import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-vue-next'
import type { Column } from '@tanstack/vue-table'
import { LIBRARY_COLUMN_NAMES } from '../consts/libraryColumnNames'
import TooltipContent from '~~/src/components/ui/tooltip/TooltipContent.vue'
import TooltipTrigger from '~~/src/components/ui/tooltip/TooltipTrigger.vue'
import Tooltip from '~~/src/components/ui/tooltip/Tooltip.vue'
import Button from '~~/src/components/ui/button/Button.vue'
import type { ColumnList } from '~~/src/types/library'

export const renderHeaderWithSorting = (column: Column<ColumnList, unknown>) => {
  const isSorted = column.getIsSorted()
  const canSort = column.getCanSort()
  const label = LIBRARY_COLUMN_NAMES[column.id]

  const icon = isSorted === 'asc'
    ? ChevronUp
    : isSorted === 'desc'
      ? ChevronDown
      : ChevronsUpDown

  const baseIconClasses = 'ml-1 h-4 w-4 transition-opacity duration-200'
  const showAlways = isSorted === 'asc' || isSorted === 'desc'

  if (!canSort) {
    return h('span', { class: 'flex items-center gap-1 text-xs color-blueGray group' }, [
      label,
      h(ChevronsUpDown, {
        class: `${baseIconClasses} opacity-0 group-hover:opacity-100`,
      }),
    ])
  }

  const tooltipText = isSorted === 'asc'
    ? 'Sorted (asc)'
    : isSorted === 'desc'
      ? 'Sorted (desc)'
      : 'Click to sort'

  return h(Tooltip, null, {
    default: () => [
      h(TooltipTrigger, { asChild: true }, {
        default: () =>
          h(Button, {
            class: 'group p-0 h-auto text-xs color-blueGray flex items-center gap-1',
            variant: 'ghost',
            onClick: () => column.toggleSorting(isSorted === 'asc'),
          }, () => [
            label,
            h(icon, {
              class: `${baseIconClasses} ${showAlways ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`,
            }),
          ]),
      }),
      h(TooltipContent, null, () => tooltipText),
    ],
  })
}
